import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../../style/Main.scss';
import '../../style/Layout.scss';
import '../../style/CommandPalette.scss';
import '../../style/Responsive.scss';
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import CommandPalette from "./CommandPalette";
import HelpCenter from "./HelpCenter";
import CopyDialog from "./CopyDialog";
import DeleteProjectDialog from "../projects/DeleteProjectDialog";
import Tour from "./Tour";
import { t } from "../../i18n";

class Layout extends Component {

  constructor(props) {
    super(props);
    // Tablette (≤ 1100 px) : barre latérale repliée par défaut pour laisser la place à l'éditeur, sauf choix déjà fait.
    let sidebarCollapsed = window.innerWidth <= 1100;
    try {
      const stored = window.localStorage.getItem('tsk-sidebar-collapsed');
      if (stored !== null) sidebarCollapsed = stored === '1';
    } catch (e) { /* localStorage unavailable */ }
    this.state = { drawerOpen: false, sidebarCollapsed };
  }

  toggleDrawer = () => {
    this.setState(({ drawerOpen }) => ({ drawerOpen: !drawerOpen }));
  };

  closeDrawer = () => {
    this.setState({ drawerOpen: false });
  };

  toggleSidebarCollapsed = () => {
    this.setState(({ sidebarCollapsed }) => {
      const next = !sidebarCollapsed;
      try {
        window.localStorage.setItem('tsk-sidebar-collapsed', next ? '1' : '0');
      } catch (e) { /* localStorage unavailable */ }
      return { sidebarCollapsed: next };
    });
  };

  render() {
    const { identityProvider } = this.props;
    const { drawerOpen, sidebarCollapsed } = this.state;

    document.getElementsByTagName('html')[0].classList.add("tsk");

    return (
      <div className={`tsk-layout${sidebarCollapsed ? ' tsk-sidebar-is-collapsed' : ''}`}>
        <button
          type='button'
          className='tsk-burger'
          aria-label='Menu'
          aria-expanded={drawerOpen}
          onClick={this.toggleDrawer}
        >
          <FontAwesomeIcon icon={['fas', drawerOpen ? 'times' : 'bars']} />
        </button>

        {/* Desktop-only: collapse/expand the structure sidebar to free screen space */}
        <button
          type='button'
          className='tsk-sidebar-collapse-toggle'
          aria-label='Toggle sidebar'
          aria-expanded={!sidebarCollapsed}
          onClick={this.toggleSidebarCollapsed}
        >
          <FontAwesomeIcon icon={['fas', sidebarCollapsed ? 'angle-double-right' : 'angle-double-left']} />
        </button>

        <CommandPalette />
        <HelpCenter />
        <CopyDialog />
        <DeleteProjectDialog />
        <Tour />

        {drawerOpen && (
          <div className='tsk-sidebar-backdrop' onClick={this.closeDrawer} />
        )}

        <div id='tsk-sidebar' className={`${drawerOpen ? 'is-open' : ''}${sidebarCollapsed ? ' is-collapsed' : ''}`}>
          <div id='tsk-main-logo'>
            <Link to='/project' className='tsk-main-logo-link' title='Retour aux interfaces' onClick={this.closeDrawer}>
              <img alt='Treeosk' src='/logo_treeosk.png' width={"100%"} height={"auto"} id='logo'/>
              <span className='tsk-layout__product-name'>Studio</span>
            </Link>
          </div>
          <button
            type='button'
            className='tsk-palette-trigger'
            onClick={() => window.dispatchEvent(new Event('tsk-open-palette'))}
          >
            <FontAwesomeIcon icon={['fas', 'search']} />
            <span>{t('ui.nav.search')}</span>
            <kbd>{/Mac/.test(navigator.platform) ? '⌘K' : 'Ctrl K'}</kbd>
          </button>
          <div className='tsk-sidebar-scroll'>
            <Sidebar identityProvider={identityProvider} onNavigate={this.closeDrawer}/>
          </div>
        </div>
        <div id='tsk-main'>
          <Topbar identityProvider={identityProvider} />
          <div className='tsk-container'>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

Layout.propTypes = {
  identityProvider: PropTypes.object.isRequired,
};

export default Layout;
